import styled from 'styled-components';

export const Title = styled.div`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 120%; /* 24px */
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	margin-top: 16px;
	flex-direction: column;
	width: 100%;

	@media (min-width: 600px) {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}
`;

export const BottomText = styled.div`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 19.6px */
	grid-column: 2;
`;

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 100%;
	gap: 30px;
	margin-top: 30px;
	margin-bottom: 10px;

	@media (min-width: 600px) {
		width: 550px;
	}
`;
